import { render, staticRenderFns } from "./wangqixianmian.vue?vue&type=template&id=3da6100f&scoped=true"
import script from "./wangqixianmian.vue?vue&type=script&lang=js"
export * from "./wangqixianmian.vue?vue&type=script&lang=js"
import style0 from "./wangqixianmian.vue?vue&type=style&index=0&id=3da6100f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6100f",
  null
  
)

export default component.exports